import { badgeColors } from 'constants/colors'
import keys from 'constants/keys'

export enum JobFrequencyType {
  ONCE = -1,
  DAILY = 0,
  WEEKLY = 1,
  MONTHLY = 2,
}

export const SERVICE_QUEUE_MAPPING = {
  [keys.JOBS_SERVICES.POPS]: 'pops_queue-scheduled_publish_pop',
  [keys.JOBS_SERVICES.COMPAIGN]: 'data_queue-trigger_create_campaign_data',
}

export const JOBS_ACTION_FREQUENCIES = [
  { id: JobFrequencyType.ONCE.toString(), name: 'once', isShowId: false },
  { id: JobFrequencyType.DAILY.toString(), name: 'daily', isShowId: false },
  { id: JobFrequencyType.WEEKLY.toString(), name: 'weekly', isShowId: false },
  { id: JobFrequencyType.MONTHLY.toString(), name: 'monthly', isShowId: false },
]

export const getFrequencyLabel = (value: number | null) => {
  switch (value) {
    case JobFrequencyType.DAILY:
      return 't_day'
    case JobFrequencyType.WEEKLY:
      return 't_week'
    case JobFrequencyType.MONTHLY:
      return 't_month'
    default:
      return 'once'
  }
}

export const getStatusColor = (status: number) => {
  switch (status) {
    case keys.JOBS_STATUS.ACTIVE:
      return badgeColors.green
    case keys.JOBS_STATUS.INACTIVE:
      return badgeColors.default
    default:
      return badgeColors.default
  }
}

export const getStatusName = (status: number) => {
  switch (status) {
    case keys.JOBS_STATUS.ACTIVE:
      return 'Active'
    case keys.JOBS_STATUS.INACTIVE:
      return 'Inactive'
    default:
      return 'Unknown'
  }
}

export const getServiceColor = (service: string) => {
  switch (service) {
    case keys.JOBS_SERVICES.POPS:
      return badgeColors.orange
    case keys.JOBS_SERVICES.COMPAIGN:
      return badgeColors.blue
    case keys.JOBS_SERVICES.TASKS:
      return badgeColors.pink
    case keys.JOBS_SERVICES.POSTS:
      return badgeColors.yellow
    case keys.JOBS_SERVICES.DATA:
      return badgeColors.gray
    default:
      return badgeColors.default
  }
}

export const getServiceName = (service: string) => {
  switch (service) {
    case keys.JOBS_SERVICES.POPS:
      return keys.JOBS_SERVICES.POPS
    case keys.JOBS_SERVICES.TASKS:
      return keys.JOBS_SERVICES.TASKS
    case keys.JOBS_SERVICES.POSTS:
      return keys.JOBS_SERVICES.POSTS
    case keys.JOBS_SERVICES.DATA:
      return keys.JOBS_SERVICES.DATA
    case keys.JOBS_SERVICES.COMPAIGN:
      return keys.JOBS_SERVICES.COMPAIGN
    default:
      return 'Unknown'
  }
}
